module.exports = __webpack_public_path__ + "img/temp_idc1.994af39f.jpg";